// MessageService — migrated to the OpenAPI-generated client.
//
// Both functions posted a raw axios `response` back; callers await the result, so we return
// `{data}` with the parsed JSON body. Auth/timezone come from configureApi's interceptor.
import {
    adminTraineeMessageControllerSendEmail,
    adminTraineeMessageControllerSendNotification,
} from "../api/generated";

const throwAsAxiosError = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

export const sendEmail = async (email) => {
    const {data, error, response} = await adminTraineeMessageControllerSendEmail({body: email});
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const sendNotification = async (notification) => {
    const {data, error, response} = await adminTraineeMessageControllerSendNotification({
        body: notification,
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};
